/* eslint-disable no-template-curly-in-string */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../theme/Hub.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { authProvider } from "../context/authProvider";
import { fetchBitacora } from "../Api/fetchBitacora";
import { UseAdmin, UseUser, UseAuth } from "../hooks";
import { VERSION_APP } from "../utilities";
import moment from "moment";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import { ModuleCard } from "../components/shared/ModuleCard";
import { GridContainer } from "../components/shared/GridContainer";
import { GridItems } from "../components/shared/GridItems";
import { DateInfo } from "../components/shared/DateInfo";
import { Card } from "../components/Card/Card";
import { PageTitle } from "../components/shared/PageTitle";

export const HubPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { employeeId, mail, device, usuario } = UseUser();
  const { brandfiMarcaId, branchFiSucursalId, branchFiPaisId, brandfiBiId } = UseAdmin();
  const { uniqueId } = UseAuth();
  const [isLoading, setLoading] = useState(true);
  const [dataHub, setDataHub] = useState(null);

  useEffect(() => {
    if (state.dataRouter) {
      setDataHub(state.dataRouter);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [state]);

  const navigateToADNalsea = (url) => {
    window.open(url, "_blank");
  };

  const navigateToKronos = (url) => {
    window.open(url, "_blank");
  };

  const navigateToEMI = (url) => {
    window.open(url, "_blank");
  };

  const navigateToDelivery = (url) => {
    const interpolatedString = url.replace(/\${([^}]+)}/g, (match, variable) => {
      switch (variable) {
        case "branchFiPaisId":
          return branchFiPaisId;
        case "brandfiMarcaId":
          return brandfiMarcaId;
        case "branchFiSucursalId":
          return branchFiSucursalId;
        case "usuario":
          return usuario;
        default:
          return match;
      }
    });
    window.open(interpolatedString, "_blank");
  };

  const navigateToAlseaCollege = (url) => {
    window.open(url, "_blank");
  };

  const navigateToMedalia = (url) => {
    window.open(url, "_blank");
  };

  const navigateToOracle = (url) => {
    window.open(url, "_blank");
  };

  const navigateToCarpetaLegal = (url) => {
    const urlInterpolada = url.replace("${branchFiSucursalId}", branchFiSucursalId);
    window.open(urlInterpolada, "_blank");
  };

  const navigateToHMC = (url) => {
    window.open(url, "_blank");
  };

  ///funciones nuevas
  const navigateToFuncionUrl = (url) => {
    window.open(url, "_blank");
  };
  const navigateToFuncionWithSSO = (url) => {
    window.open(url, "_blank");
  };
  const navigateToFuncionWithData = (url) => {
    const interpolatedString = url.replace(/\${([^}]+)}/g, (match, variable) => {
      switch (variable) {
        case "branchFiPaisId":
          return branchFiPaisId;
        case "brandfiMarcaId":
          return brandfiMarcaId;
        case "branchFiSucursalId":
          return branchFiSucursalId;
        case "brandfiBiId":
          return brandfiBiId;
        case "usuario":
          return usuario;
        default:
          return match;
      }
    });
    window.open(interpolatedString, "_blank");
  };
  const navigateToFuncionStack = (url, child2) => {
    navigate(`/${url} `, { state: { dataRouter: child2 } });
  };

  const handleClickLink = (itemPress, urlPress) => {
    if (itemPress === "navigateToADNalsea") {
      navigateToADNalsea(urlPress);
    } else if (itemPress === "navigateToKronos") {
      navigateToKronos(urlPress);
    } else if (itemPress === "navigateToEMI") {
      navigateToEMI(urlPress);
    } else if (itemPress === "navigateToDelivery") {
      navigateToDelivery(urlPress);
    } else if (itemPress === "navigateToAlseaCollege") {
      navigateToAlseaCollege(urlPress);
    } else if (itemPress === "navigateToMedalia") {
      navigateToMedalia(urlPress);
    } else if (itemPress === "navigateToOracle") {
      navigateToOracle(urlPress);
    } else if (itemPress === "navigateToCarpetaLegal") {
      navigateToCarpetaLegal(urlPress);
    } else if (itemPress === "navigateToHMC") {
      navigateToHMC(urlPress);
    } else if (itemPress === "navigateToFuncionUrl") {
      navigateToFuncionUrl(urlPress);
    } else if (itemPress === "navigateToFuncionWithSSO") {
      navigateToFuncionWithSSO(urlPress);
    } else if (itemPress === "navigateToFuncionWithData") {
      navigateToFuncionWithData(urlPress);
    } else if (itemPress === "navigateToFuncionStack") {
      navigateToFuncionStack(urlPress);
    }
  };

  const handleButtonPress = (item) => {
    console.log("handleButtonPress", item.FCTERCERASECCION);
    handleClickLink(item.FCJSONSECCION3, item.FCLINKSECCION3);
    logEvent(analytics, "handleOnPressButton", {
      mail: mail,
      version: VERSION_APP,
      handleClick: item.FCTERCERASECCION,
      seccion: item.FCJSONSECCION3,
      employeeId: employeeId,
      brandfiMarcaId: brandfiMarcaId,
      branchFiSucursalId: branchFiSucursalId,
      branchFiPaisId: branchFiPaisId,
      deviceInfo: device,
    });
    getBitacora("code 200", item.FCJSONSECCION3, `Hub-${item.FCTERCERASECCION}`);
  };

  const getBitacora = async (data, config, description) => {
    const deviceWeb = `${uniqueId}-${device}`;
    const key = `${uniqueId}-${device}-${employeeId}`;
    const obtenerFechaEnFormato = () => {
      const ahora = moment();
      // Agrega 5 segundos a la fecha actual
      ahora.add(2, "seconds");
      const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
      return fechaEnFormato;
    };
    const fechaActualEnFormato = obtenerFechaEnFormato();
    if (brandfiMarcaId != null && config != null && data != null) {
      const onFailure = (error) => {};
      const onSuccess = ({ data }) => {};
      fetchBitacora(
        mail,
        deviceWeb,
        fechaActualEnFormato,
        key,
        config,
        data,
        description,
        VERSION_APP,
        employeeId,
        brandfiMarcaId,
        branchFiSucursalId,
        branchFiPaisId
      )
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-hub">
                <BtnGoBack caption="Volver a inicio" />
              </div>

              <PageTitle title="Hub del gerente" />

              <div className="body-home">
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <Card>
                    <div className="wellcome-content hub-wellcome-content">
                      <div className="wellcome-content-title">
                        <p className="wellcome-content-grettings">¡Hola!</p>
                        <p className="wellcome-content-name">{accountInfo.account.name}</p>
                      </div>

                      <DateInfo />
                    </div>

                    <GridContainer>
                      {dataHub && (
                        <GridItems>
                          {dataHub.map((item) => (
                            <ModuleCard
                              key={item.FCKEY}
                              item={item}
                              onClick={() => handleButtonPress(item)}
                            />
                          ))}
                        </GridItems>
                      )}
                    </GridContainer>
                  </Card>
                )}
              </div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
